import Swal from 'sweetalert2'
import Colors from '../../constants/Colors'

const sortOrderByCreatedAt = (a, b) => {
  let x = new Date(a.createdAt)
  let y = new Date(b.createdAt)
  return x - y
}

const alertCompleted = async () => {
  await Swal.fire({
    icon: 'success',
    title: 'สำเร็จ',
    showCloseButton: true,
    confirmButtonText: 'ปิด',
    confirmButtonColor: Colors.GREEN,
  })
}

const alertError = (text) => {
  Swal.fire({
    icon: 'error',
    title: text || 'เกิดข้อผิดพลาด',
    showCloseButton: true,
    confirmButtonText: 'ปิด',
    confirmButtonColor: Colors.LIGHT_RED,
  })
}

const alertBeforeHandle = (text, onFunc) => {
  Swal.fire({
    title: text,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: Colors.SOFT_BLUE,
    cancelButtonColor: Colors.LIGHT_RED,
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
  }).then(async (result) => {
    if (result.isConfirmed) {
      await onFunc()
    }
  })
}

export { sortOrderByCreatedAt, alertCompleted, alertError, alertBeforeHandle }
